import { createParser, system } from "@styled-system/core";
var config = {
  transition: true,
  transitionDuration: {
    property: "transitionDuration",
    scale: "transition.duration"
  },
  transitionProperty: {
    property: "transitionProperty",
    scale: "transition.property"
  },
  transitionTimingFunction: {
    property: "transitionTimingFunction",
    scale: "transition.timingFunction"
  }
};
export var transition = system(config);
export var transitionParser = createParser(config);
//# sourceMappingURL=transition.js.map